/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var metrics  = require('mag-app').metrics,
    icons = require('magcore-theme/icons'),
    tools = require('./tools'),
    $node = window.floatingPanel,
    $number = window.floatingPanelNumber,
    // $responsiveWrapper = window.floatingPanelResponsive,
    $logo = window.floatingPanelLogo,
    $titleWrap = window.floatingPanelTitleWrapper,
    $name = window.floatingPanelTitle,
    $epg = window.floatingPanelEpg,
    // $iconsWrapper = document.createElement('div'),
    $favoriteIcon = window.floatingPanelFavorite,
    $timeShiftIcon = window.floatingPanelTS,
    $lockIcon = window.floatingPanelLock,

    STYLED_TEXT_CLASS = ' theme-styled-text';

$name.className += STYLED_TEXT_CLASS;
$epg.className += STYLED_TEXT_CLASS;

$favoriteIcon.className = icons.FAVORITE_ACTIVE + ' active';
$timeShiftIcon.className = icons.TIMESHIFT + STYLED_TEXT_CLASS;
$lockIcon.className += icons.LOCK + STYLED_TEXT_CLASS;


module.exports = function ( config ) {
    $number.style.backgroundColor = config.specialColor;

    return function ( channel, focusIndex ) {
        var iconsCount = 0;

        if ( !channel ) {
            return;
        }

        if ( focusIndex !== undefined ) {
            $node.style.top = ( (focusIndex * metrics.floatingPanelStep) - metrics.floatingPanelStepPadding) + 'px';
        }

        $number.innerText = channel.number || '';
        if ( channel.logo ) {
            $logo.style.backgroundImage = 'url(' + core.backend.host + channel.logo + ')';
        } else {
            $logo.style.backgroundImage = '';
        }

        $name.innerText = channel.name || '';

        if ( channel.currentEpg ) {
            let startTime = new Date(channel.currentEpg.start * 1000),
                hours = startTime.getHours(),
                min = startTime.getMinutes();

            if ( min < 10 ) {
                min = '0' + min;
            }

            $epg.innerText = `${hours}:${min} ${channel.currentEpg.title || ''}`;
            $name.classList.remove('no-epg');
        } else {
            $epg.innerText = '';
            $name.classList.add('no-epg');
        }

        if ( channel.favorite ) {
            $favoriteIcon.classList.add('visible');
            iconsCount++;
        } else {
            $favoriteIcon.classList.remove('visible');
        }

        if ( tools.isCensored(channel) ) {
            $lockIcon.classList.add('visible');
            iconsCount++;
        } else {
            $lockIcon.classList.remove('visible');
        }

        if ( channel.local_timeshift || (channel.archive && channel.archive_range) ) {
            $timeShiftIcon.classList.add('visible');
            iconsCount++;
        } else {
            $timeShiftIcon.classList.remove('visible');
        }

        $titleWrap.className = 'title-wrapper icons-' + iconsCount;
    };
};
